module.exports = __webpack_public_path__ + "img/process-w.f2e9b77a.svg";